(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ShowprojectsTowerofficerController', ShowprojectsTowerofficerController);

    ShowprojectsTowerofficerController.$inject = ['$scope', '$filter', 'ShowprojectsTowerofficerService', 'ForceMajeureService'];

    function ShowprojectsTowerofficerController($scope, $filter , ShowprojectsTowerofficerService, ForceMajeureService) {

        /**
         * The only service that is intimated rather than cleared -
         * Communication and Connectivity Permissions/Renewal(Above Ground).
         */
        var ABOVE_GROUND_SERVICE_ID = '58d75fd4-f360-4931-a484-ff9be0adc12c';

        /** ..and only when the tower does not stand on a public property. */
        var OTHER_THAN_PUBLIC_PROPERTY = 'other than public property';

        /** The form filled on date counts as the first of the 15 days. */
        var CLARIFY_WINDOW_DAYS = 15;

        /** The status an intimation of such a tower is acknowledged on. */
        var STATUS_ACKNOWLEDGED = 'Acknowledged';

        var vm = this;
        vm.projects = [];
        vm.status='Pending';
        vm.projects.isForceMajeure = false;
        vm.showFormFilledOnDate = false;
        vm.isTowerServiceForClarification = isTowerServiceForClarification;

        loadAll();

        function loadAll() {
            ShowprojectsTowerofficerService.query({ status: vm.status }, function (result) {

                vm.projects = $filter('filter')(result, { formfilledstatus: true });

                // Form filled on date is only relevant once the service was acknowledged.
                vm.showFormFilledOnDate = vm.status === 'Acknowledged';

                angular.forEach(vm.projects, function (project) {
                    checkForceMajeure(project);
                    project.canClarify = canClarify(project);
                    project.canDecideIntimation = canDecideIntimation(project);
                });
            });
        }

        function checkForceMajeure(project) {

            ForceMajeureService.checkForceMajeure(
                { district: project.district },
                function (responseArray) {

                    if (responseArray && responseArray.length > 0) {
                        project.isForceMajeure = true;
                    } else {
                        project.isForceMajeure = false;
                    }
                }
            );
        }


        /**
         * The application may be clarified for 15 days from the day its service form
         * was filled - that day included, so a form filled today leaves 14 more days.
         *
         * Only once: an application that has already been clarified keeps that stamp for
         * good, so the button does not come back when the applicant answers and the
         * reverted flag is taken off again.
         */
        function canClarify(project) {
            if (!isAboveGroundIntimation(project)) {
                return false;
            }
            if (project.clarifiedOnce) {
                return false;
            }
            if (project.reverted) {
                return false;
            }
            if (!project.formFilledOnDate) {
                return false;
            }

            var filledOn = new Date(project.formFilledOnDate);
            if (isNaN(filledOn.getTime())) {
                return false;
            }

            return daysSince(filledOn) < CLARIFY_WINDOW_DAYS;
        }

        /**
         * An acknowledged intimation is the officer's to approve or reject - approving
         * it stands it as valid, rejecting it takes it away, and either way the
         * application leaves the acknowledged state and the buttons go with it.
         */
        function canDecideIntimation(project) {
            return isAboveGroundIntimation(project) && project.status === STATUS_ACKNOWLEDGED;
        }

        /** Above Ground, on a property the applicant does not share with a public entity. */
        function isAboveGroundIntimation(project) {
            if (!project.serviceid || project.serviceid.toLowerCase() !== ABOVE_GROUND_SERVICE_ID) {
                return false;
            }

            return !!project.property
                && project.property.trim().toLowerCase() === OTHER_THAN_PUBLIC_PROPERTY;
        }

        /**
         * Whole days between the two dates, counted on the calendar - a form filled
         * late in the evening still gets every one of its days.
         */
        function daysSince(date) {
            var from = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

            return Math.round((today - from) / 86400000);
        }

        function isTowerServiceForClarification(serviceId) {

                return !!((serviceId === '5f8e0757-e88b-4ef1-bb15-00a9e984b9b1' || serviceId === '58d75fd4-f360-4931-a484-ff9be0adc12c' || serviceId === '741f0f60-cf69-4659-8b19-19d96ffe0103' || serviceId === 'fc1b1635-d3dc-4d30-a5fd-5abf6381594d' || serviceId === '6f81801c-59c6-4773-9f37-a5d81172a1bf' || serviceId === '240d2c66-b6cc-4a0c-b5f0-3f6717177810'));

        }


        vm.statusSelected=function () {
            loadAll();
        };
    }
})();
